export function twentyCountArray() {
  let countArray = [];
  for (let i = 0; i < 21; i++) {
    countArray.push(i);
  }
  return countArray;
}
